import React from "react";
import "./style.scss";

const SubTitle = ({ label, className }) => {
  return <p className={`subTitle ${className ? className : ""}`}>{label}</p>;
};

export default SubTitle;
